/**
 * Для отладки, потом все скрипты будут вынесены в сборку.
 */

$(document).ready(function(){

    let current_report_number_internal = "";
    
    function setLocation(curLoc){
        try {
            history.pushState(null, null, curLoc);
            return;
        } catch(e) {}
        location.hash = '#' + curLoc;
    }


    //  Rigs
    // service
    //

    $('#rigssearch-name').on('change', function(e){
        $(this).closest('form').submit();
    });

    $('#rigsLoadRegions').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#rigsBlockRegions').append(data.content);
                            }
                        }
                    }
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });

    $('#rigsBlockRegions').on('click', '.search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#UserRigSearchForm');
        var test = $(formObj).find('.region-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="region-hide" name="region_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
    });



    $('#RigsFilterApply .search-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#UserRigSearchForm');
        $(formObj).find('.region-hide, .sphere-hide').remove();
        $(formObj).find('#rigssearch-user_id').val('');
        $(formObj).submit();
    });

    $('#RigsFilterApply .search-region-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#UserRigSearchForm');
        var res = $(formObj).find('.region-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        $(res).remove();
        $(formObj).submit();
    });

    $('#RigsFilterApply .search-user-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#UserRigSearchForm');
        $(formObj).find('#rigssearch-user_id').val('');
        $(formObj).submit();
    });



    //
    // service
    //
    
    $('#servicesearch-name').on('change', function(e){
        $(this).closest('form').submit();
    });
    
    $('#serviceLoadRegions').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#serviceBlockRegions').append(data.content);
                            }
                        }
                    }    
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });
    
    $('#serviceBlockRegions').on('click', '.search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ServiceSearchForm');
        var test = $(formObj).find('.region-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="region-hide" name="region_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
    });    
    
    $('#serviceLoadSpheres').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#serviceBlockSpheres').append(data.content);
                            }
                        }
                    }    
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });
    
    $('#serviceBlockSpheres').on('click', '.search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ServiceSearchForm');
        var test = $(formObj).find('.sphere-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="sphere-hide" name="sphere_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
    });
    
    $('#ServiceFilterApply .search-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ServiceSearchForm');
        $(formObj).find('.region-hide, .sphere-hide').remove();
        $(formObj).find('#servicesearch-user_id').val('');
        $(formObj).submit();
    });
    
    $('#ServiceFilterApply .search-region-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ServiceSearchForm');
        var res = $(formObj).find('.region-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#ServiceFilterApply .search-sphere-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ServiceSearchForm');
        var res = $(formObj).find('.sphere-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#ServiceFilterApply .search-user-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ServiceSearchForm');
        $(formObj).find('#servicesearch-user_id').val('');
        $(formObj).submit();
    });
    
    //
    // tenders
    //
    
    $('#tenderLoadRegions').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#tenderBlockRegions').append(data.content);
                            }
                        }
                    }    
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });
    
    $('#tenderBlockRegions').on('click', '.search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#TenderSearchForm');
        var test = $(formObj).find('.region-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="region-hide" name="region_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
    });
    
    $('#tenderLoadSpheres').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#tenderBlockSpheres').append(data.content);
                            }
                        }
                    }    
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });
    
    $('#tenderBlockSpheres').on('click', '.search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#TenderSearchForm');
        var test = $(formObj).find('.sphere-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="sphere-hide" name="sphere_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
    });
    
    $('#TenderFilterApply .search-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#TenderSearchForm');
        $(formObj).find('.region-hide, .sphere-hide').remove();
        $(formObj).find('#tendersearch-user_id').val('');
        $(formObj).submit();
    });
    
    $('#TenderFilterApply .search-region-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#TenderSearchForm');
        var res = $(formObj).find('.region-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#TenderFilterApply .search-sphere-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#TenderSearchForm');
        var res = $(formObj).find('.sphere-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#TenderFilterApply .search-user-reset').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#TenderSearchForm');
        $(formObj).find('#tendersearch-user_id').val('');
        $(formObj).submit();
    });
    
    //
    // archive
    //
    
    function archiveSearchFormUseAjax() {
        var formObj = $('#ArchiveSearchForm');
        var useAjax = parseInt($(formObj).attr('data-use-ajax'));
        if (useAjax) return true;
        return false;    
    }

    $('#step2Button').on('mouseover', function(e){
        if (current_report_number_internal != $('#Archive_report_number_internal').val()) {
            $('#Archive_report_number_internal').blur();
            current_report_number_internal = $('#Archive_report_number_internal').val();
        }
    });

    $('#Archive_report_number_internal').on('blur', function(e){
        let number_val = $(this).val();
        current_report_number_internal = number_val;
        if (number_val == '') return;
        $.ajax({
            type: "POST",
            url: $(this).attr('data-url'),
            data: {report_number_internal:number_val},
            dataType: 'json',
            success: function(data) {
                if(data.unique === false) {
                    $('#report_number_internal_alert_message').text(data.message);
                    $('#report_number_internal_alert').addClass('show');
                } else {
                    $('#report_number_internal_alert').removeClass('show');
                    $('#report_number_internal_alert_message').text('');
                }
            },
         });

    });
    
    $('#archivesearch-name').on('change', function(e){
        $(this).closest('form').submit();
    });

    //Поиск по типу владельца услуги
    $('#UserRigSearchForm #rigssearch-owner_type').on('change', function(e){
        var obj = this;
        var val = $(obj).val();
        $(this).closest('form').submit();
        return;
    });

    $('#RigsFilterApply').on('click', '.search-owner_type-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#UserRigSearchForm');
        $(formObj).find('.search-owner_type').val('0');
        $(formObj).submit();
    });


    $('#ServiceSearchForm #servicesearch-owner_type').on('change', function(e){
        var obj = this;
        var val = $(obj).val();
        $(this).closest('form').submit();
        return;
    });

    $('#ServiceFilterApply').on('click', '.search-owner_type-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ServiceSearchForm');
        $(formObj).find('.search-owner_type').val('0');
        $(formObj).submit();
    });

    //Поиск по типу
    $('#ArchiveSearchForm #archivesearch-type').on('change', function(e){
        var obj = this;
        var val = $(obj).val();
        $(this).closest('form').submit();
        var useAjax = archiveSearchFormUseAjax();
        if (!useAjax) return;
        if (val == 0) {val = '';}
        if (val != '') {
            var text = '';
            if (val == '1'){
                text = "Только размещенные";
            } else if (val == '2') {
                text = "Только заявки";
            }
            var test = $('#ArchiveFilterApply .search-type-label').length;
            if (test) {
                $('#ArchiveFilterApply .search-type-label').html(text);
            } else {
                var _data = {
                    name: text,
                    classReset: 'search-type-reset',
                    classLabel: 'search-type-label',
                };
                archiveFilterApplyAddFilter(_data);
            }
        } else {
            $('#ArchiveFilterApply .search-type-reset').closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
    });

    $('#ArchiveFilterApply').on('click', '.search-type-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ArchiveSearchForm');
        $(formObj).find('.search-type').val('0');
        var useAjax = archiveSearchFormUseAjax();
        if (useAjax) {
            $(obj).closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
        $(formObj).submit();
    });
    
    $('#archivesearch-selectUser').select2({
        placeholder: 'Выберите владельца...',
        minimumInputLength: 3,
        language: {
            errorLoading: function() {
                return 'Ожидание загрузки результата...'; 
            },
        },
        ajax: {
            url: $('#archivesearch-selectUser').attr('data-url'),
            dataType: 'json',
            data: function(params) {
                return {q:params.term}; 
            }
        },
        escapeMarkup: function(markup) { 
            return markup; 
        },
        templateResult: function(item) { 
            return item.text;
        },
        templateSelection: function(item) {
            return item.text; 
        }
    });
    
    $('#archivesearch-selectUser').on('select2:select', function (e) {
        var objSel = this;
        var data = e.params.data;
        if (('id' in data) && data.id) {
            var dataId = data.id;
            var formObj = $('#ArchiveSearchForm');
            var test = $(formObj).find('.user-hide[data-id=' + dataId + ']').length;
            if (!test) {
                var content = '<input type="hidden" class="user-hide" name="user_id[]" value="'
                    + dataId + '" data-id="' + dataId + '">';
                $(formObj).append(content);
                $(formObj).submit();
                
                if (archiveSearchFormUseAjax()) {
                    var _data = {
                        id: dataId,
                        name: data.text,
                        classReset: 'search-user-reset',    
                    };
                    archiveFilterApplyAddFilter(_data);
                }   
            }
        }
        $(objSel).val('').trigger('change');
    });
    
    $('#archiveMainBlockRegions').on('click', '#archiveLoadRegions', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#archiveBlockRegions').append(data.content);
                            }
                        }
                    }    
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });
    
    $('#archiveMainBlockRegions').on('click', '#archiveBlockRegions .search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ArchiveSearchForm');
        var test = $(formObj).find('.region-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="region-hide" name="region_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
        
        if (archiveSearchFormUseAjax()) {
            var _data = {
                id: dataId,
                name: $(obj).find('.search-form-list-item-name').text(),
                classReset: 'search-region-reset',    
            };
            archiveFilterApplyAddFilter(_data);
        }
    });    
    
    $('#archiveMainBlockSpheres').on('click', '#archiveLoadSpheres', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var actionUrl = $(this).attr('href');
        if (actionUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: actionUrl,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            if (data.content) {
                                $('#archiveBlockSpheres').append(data.content);
                            }
                        }
                    }    
                    if ('nextUrl' in data) {
                        if (data.nextUrl) $(obj).attr('href', data.nextUrl);
                        else $(obj).remove();
                    }
                }
            });
        }
    });
    
    $('#archiveMainBlockSpheres').on('click', '#archiveBlockSpheres .search-form-list-item', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ArchiveSearchForm');
        var test = $(formObj).find('.sphere-hide[data-id=' + dataId + ']').length;
        if (test) return;
        var content = '<input type="hidden" class="sphere-hide" name="sphere_id[]" value="'
            + dataId + '" data-id="' + dataId + '">';
        $(formObj).append(content);
        $(formObj).submit();
        if (archiveSearchFormUseAjax()) {
            var _data = {
                id: dataId,
                name: $(obj).find('.search-form-list-item-name').text(),
                classReset: 'search-sphere-reset',    
            };
            archiveFilterApplyAddFilter(_data);
        }
    });
    
    $.HSCore.components.HSDatepicker.init('#datepickerFrom');
    var dateMin = $('#datepickerFrom').attr('data-date-min');
    var dateMax = $('#datepickerFrom').attr('data-date-max');
    if (dateMin && dateMax) {
        $('#datepickerFrom').datepicker('option', {
            minDate: dateMin,
            maxDate: dateMax,
        });
    }
    dateMin = $('#datepickerTo').attr('data-date-min');
    dateMax = $('#datepickerTo').attr('data-date-max');
    if (dateMin && dateMax) {
        $('#datepickerTo').datepicker('option', {
            minDate: dateMin,
            maxDate: dateMax,
        });
    }
    
    $('#ArchiveSearchForm .search-date-start').on('change', function(e){
        var obj = this;
        var val = $(obj).val();
        $(this).closest('form').submit();
        var useAjax = archiveSearchFormUseAjax();
        if (!useAjax) return;
        if (val != '') {
            var test = $('#ArchiveFilterApply .search-date-start-label').length;
            if (test) {
                $('#ArchiveFilterApply .search-date-start-label').html('с ' + val);
            } else {
                var _data = {
                    name: 'c ' + val,
                    classReset: 'search-date-start-reset',
                    classLabel: 'search-date-start-label',    
                };
                archiveFilterApplyAddFilter(_data);    
            }
        } else {
            $('#ArchiveFilterApply .search-date-start-reset').closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
    });
    
    $('#ArchiveSearchForm .search-date-end').on('change', function(e){
        var obj = this;
        var val = $(obj).val();
        $(this).closest('form').submit();
        var useAjax = archiveSearchFormUseAjax();
        if (!useAjax) return;
        if (val != '') {
            var test = $('#ArchiveFilterApply .search-date-end-label').length;
            if (test) {
                $('#ArchiveFilterApply .search-date-end-label').html('по ' + val);
            } else {
                var _data = {
                    name: 'по ' + val,
                    classReset: 'search-date-end-reset',
                    classLabel: 'search-date-end-label',    
                };
                archiveFilterApplyAddFilter(_data);    
            }
        } else {
            $('#ArchiveFilterApply .search-date-end-reset').closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
    });
    
    $.HSCore.components.HSSlider.init('#archivesearch-drillDepthSlider');
    $('#archivesearch-drillDepthSlider').on('slidechange', function(e, ui){
        $('#archivesearch-drill_depth_range').val(ui.values[0] + ',' + ui.values[1]);
        $(this).closest('form').submit();
        var useAjax = archiveSearchFormUseAjax();
        if (!useAjax) return;
        var slider = $(this);
        var valMinDef = $(slider).slider('option', 'min');
        var valMaxDef = $(slider).slider('option', 'max');
        var valMin = ui.values[0];
        var valMax = ui.values[1];        
        var val = valMin + ' - ' + valMax;
        $('#archivesearch-drillDepthSliderAmount').html(val);
        if (! ((valMin == valMinDef) && (valMax == valMaxDef)) ) {
            var valMetr = val + ' м';
            var test = $('#ArchiveFilterApply .search-drill-depth-label').length;
            if (test) {
                $('#ArchiveFilterApply .search-drill-depth-label').html(valMetr);
            } else {
                var _data = {
                    name: valMetr,
                    classReset: 'search-drill-depth-reset',
                    classLabel: 'search-drill-depth-label',    
                };
                archiveFilterApplyAddFilter(_data);    
            }
        } else {
            $('#ArchiveFilterApply .search-drill-depth-reset').closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
    });


    //Убираем пустые данные форм
    $('#ServiceSearchForm, #TenderSearchForm, #UserRigSearchForm').on('submit', function(e){

        e.preventDefault();

        var query = $(this).serializeArray().filter(function (i) {
            if (i.name == 'owner_type' && i.value == 0) {return null}
            return i.value;
        });


        window.location.href = $(this).attr('action') + ($.param(query) ? '?' + $.param(query) : '');


    });

    
    $('#ArchiveSearchForm').on('submit', function(e){
        var formObj = $(this);
        var useAjax = archiveSearchFormUseAjax();

        if (!useAjax) { //Если это не Ajax - убираем пустые значения полей
            e.preventDefault();

            var query = $(this).serializeArray().filter(function (i) {
                if (i.name == 'type' && i.value == 0) {return null;}
                if (i.name == 'drill_depth_range' && $('#archivesearch-drill_depth_range').attr('data-defval') == i.value) {
                    return null;
                }
                //console.log(i.value);
                return i.value;
            });

            window.location.href = $(this).attr('action') + ($.param(query) ? '?' + $.param(query) : '');
            //return true;
        }

        if (!(('mapBox' in window) && ('mapBox_remoteObjectManager' in window))) {
            return true;
        }
        var formObj = $(this);
        var mapBox = window.mapBox;
        var remoteObjectManager = window.mapBox_remoteObjectManager;
        var mapObj = $('#mapBox');
        var bboxUrl = $(mapObj).attr('data-bbox-url');
        var boundaryUrl = $(mapObj).attr('data-boundary-url');
        var totalCountUrl = $(mapObj).attr('data-total-count-url');
        if (!(bboxUrl && boundaryUrl && totalCountUrl)) return true;

        //console.log('ArchiveSearchForm');
        //$("#ArchiveSearchForm :input[value!='']").serialize()
        /*
        var form_data = $("#ArchiveSearchForm :input")
            .filter(function(index, element) {
                return $(element).val() != '';
            })
            .serialize();

         */
        var query1 = $(this).serializeArray().filter(function (i) {
            if (i.name == 'type' && i.value == 0) {return null;}
            if (i.name == 'drill_depth_range' && $('#archivesearch-drill_depth_range').attr('data-defval') == i.value) {
                return null;
            }
            //console.log(i.value);
            return i.value;
        });

        var form_data = $.param(query1) ? $.param(query1) : '';
        
        $.ajax({
            cache: false,
            dataType: 'json',
            url: boundaryUrl + '?' + form_data,
            success: function(data) {
                if (('success' in data) && ('data' in data)) {
                    if (data.success) {
                        var _bboxUrl = bboxUrl + '&' + $(formObj).serialize(); 
                        remoteObjectManager.setUrlTemplate(_bboxUrl);
                        var mapBounds = data.data;
                        if (mapBounds && ('type' in mapBounds)) {
                            if (mapBounds.type == 'point') {
                                mapBox.setCenter(mapBounds.coords);
                            } else if (mapBounds.type == 'bbox') {
                                mapBox.setBounds(mapBounds.coords);
                            }
                        }
                        remoteObjectManager.reloadData();
                    }
                }    
            }
        });
        
        $.ajax({
            cache: false,
            dataType: 'json',
            url: totalCountUrl + '?' + form_data,
            success: function(data) {
                if (('success' in data) && ('data' in data)) {
                    if (data.success) {
                        $('#archiveSearchResult_findLabel').html(data.data.findLabel);
                        $('#archiveSearchResult_totalCount').html(data.data.count);
                        $('#archiveSearchResult_label').html(data.data.label);
                    }
                }    
            }
        });
        
        var regionsUrl = $('#archiveMainBlockRegions').attr('data-url');
        if (regionsUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: regionsUrl,
                data: form_data,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            $('#archiveMainBlockRegions').html(data.content);
                        }
                    }
                }
            });
        }
        
        var spheresUrl = $('#archiveMainBlockSpheres').attr('data-url');
        if (spheresUrl) {
            $.ajax({
                cache: false,
                dataType: 'json',
                url: spheresUrl,
                data: form_data,
                success: function(data) {
                    if (('success' in data) && ('content' in data)) {
                        if (data.success) {
                            $('#archiveMainBlockSpheres').html(data.content);
                        }
                    }
                }
            });
        }
        
        var location = $(formObj).attr('action') + ((form_data != '') ? '?' + form_data : '');
        setLocation(location);
        
        var listUrl = $(formObj).attr('data-list-url') + ((form_data != '') ? '?' + form_data : '');
        $('#archiveSearchListUrl').attr('href', listUrl);
        
        return false;
    });
    
    function archiveFilterApplyItemTpl(data) {
        var content = '\
            <div class="col-auto g-px-4 search-filter-item">\
                <div class="btn btn-outline-primary g-bg-white g-bg-primary--hover g-font-weight-600 g-font-size-13 g-cursor-default g-px-16 g-py-10 mb-2">\
                    <span class="{{data.classLabel}}">{{data.name}}</span>\
                    <a class="{{data.classReset}} text-reset g-ml-5" href="#" data-id="{{data.id}}"><i class="fas fa-times"></i></a>\
                </div>\
            </div>\
        ';
        var val = '';
        val = ('id' in data) ? data.id : ''; 
        content = content.replace(/{{data.id}}/g, val);
        val = ('name' in data) ? data.name : ''; 
        content = content.replace(/{{data.name}}/g, val);
        val = ('classReset' in data) ? data.classReset : ''; 
        content = content.replace(/{{data.classReset}}/g, val);
        val = ('classLabel' in data) ? data.classLabel : ''; 
        content = content.replace(/{{data.classLabel}}/g, val);
        return content;
    }
    
    function archiveFilterApplyAddFilter(data) {
        var content = archiveFilterApplyItemTpl(data);
        $('#ArchiveFilterApply .search-filter-body').append(content);
        archiveFilterApplyShow();
    }
    
    function archiveFilterApplyShow() {
        $('#ArchiveFilterApply').show();
    }
    
    function archiveFilterApplyAutoShow() {
        var test = $('#ArchiveFilterApply .search-filter-item').length;
        if (test) $('#ArchiveFilterApply').show();
    }
    
    function archiveFilterApplyHide() {
        $('#ArchiveFilterApply').hide();
    }
    
    function archiveFilterApplyAutoHide() {
        var test = $('#ArchiveFilterApply .search-filter-item').length;
        if (!test) $('#ArchiveFilterApply').hide();
    }
    
    $('#ArchiveFilterApply').on('click', '.search-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ArchiveSearchForm');
        var useAjax = archiveSearchFormUseAjax();
        $(formObj).find('.user-hide, .region-hide, .sphere-hide').remove();
        $(formObj).find('.search-date-start').val('');
        $(formObj).find('.search-date-end').val('');
        $(formObj).find('.search-type').val('0');
        var slider = $('#archivesearch-drillDepthSlider');
        var valMinDef = $(slider).slider('option', 'min');
        var valMaxDef = $(slider).slider('option', 'max');
        $(slider).slider('values', [valMinDef, valMaxDef]);
        $(formObj).submit();
        if (useAjax) {
            $('#ArchiveFilterApply').find('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
    });
    
    $('#ArchiveFilterApply').on('click', '.search-region-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ArchiveSearchForm');
        var res = $(formObj).find('.region-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        var useAjax = archiveSearchFormUseAjax();
        if (useAjax) {
            $(obj).closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#ArchiveFilterApply').on('click', '.search-sphere-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ArchiveSearchForm');
        var res = $(formObj).find('.sphere-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        var useAjax = archiveSearchFormUseAjax();
        if (useAjax) {
            $(obj).closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#ArchiveFilterApply').on('click', '.search-user-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var dataId = parseInt($(obj).attr('data-id'));
        if (!dataId) return;
        var formObj = $('#ArchiveSearchForm');
        var res = $(formObj).find('.user-hide[data-id=' + dataId + ']');
        if (!res.length) return;
        var useAjax = archiveSearchFormUseAjax();
        if (useAjax) {
            $(obj).closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
        $(res).remove();
        $(formObj).submit();
    });
    
    $('#ArchiveFilterApply').on('click', '.search-date-start-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ArchiveSearchForm');
        $(formObj).find('.search-date-start').val('');
        var useAjax = archiveSearchFormUseAjax();
        if (useAjax) {
            $(obj).closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
        $(formObj).submit();
    });
    
    $('#ArchiveFilterApply').on('click', '.search-date-end-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ArchiveSearchForm');
        $(formObj).find('.search-date-end').val('');
        var useAjax = archiveSearchFormUseAjax();
        if (useAjax) {
            $(obj).closest('.search-filter-item').remove();
            archiveFilterApplyAutoHide();
        }
        $(formObj).submit();
    });
    
    $('#ArchiveFilterApply').on('click', '.search-drill-depth-reset', function(e){
        e.preventDefault();
        e.stopPropagation();
        var obj = this;
        var formObj = $('#ArchiveSearchForm');
        var slider = $('#archivesearch-drillDepthSlider');
        var valMinDef = $(slider).slider('option', 'min');
        var valMaxDef = $(slider).slider('option', 'max');
        $(slider).slider('values', [valMinDef, valMaxDef]);
    });
    
    //
    // comments
    //
    
    function loadComments() {
        $('#loadComments').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            var obj = this;
            var actionUrl = $(this).attr('href');
            if (actionUrl) {
                $.ajax({
                    cache: false,
                    dataType: 'json',
                    url: actionUrl,
                    success: function(data) {
                        if (('success' in data) && ('content' in data)) {
                            if (data.success) {
                                if (data.content) {
                                    $(obj).after(data.content);
                                    $(obj).remove();
                                    loadComments();
                                }
                            }
                        }    
                    }
                });
            }
        });
    }
    
    loadComments();
    
    //
    // tender requests
    //
    
    function loadTenderRequests() {
        $('#loadTenderRequests').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            var obj = this;
            var actionUrl = $(this).attr('href');
            if (actionUrl) {
                $.ajax({
                    cache: false,
                    dataType: 'json',
                    url: actionUrl,
                    success: function(data) {
                        if (('success' in data) && ('content' in data)) {
                            if (data.success) {
                                if (data.content) {
                                    $(obj).after(data.content);
                                    $(obj).remove();
                                    loadTenderRequests();
                                }
                            }
                        }    
                    }
                });
            }
        });
    }
    
    loadTenderRequests();
    
    $('.notice-select-items').on('change', function(){
        var val = $(this).val();
        if (this.checked) {
            $(this).closest('table').find('tbody input[type="checkbox"]').prop('checked', true);
        } else {
            $(this).closest('table').find('tbody input[type="checkbox"]').prop('checked', false);
        }
    });

    $('.notice-submit').on('click', function(){
        var pks = []; 
        $('.notice-items tbody input[type="checkbox"]:checked').each(function(){
            pks[pks.length] = $(this).val();
        });
        if (!pks.length) return false;
        $('.js-grid-pks').val(pks);
    });
    
    function updateNotice() {
        if (!$('.notice-block-val').length) return;
        if (typeof gNoticeUrl === 'undefined') return;
        var val = $('.notice-block-val').first().html();
        $.ajax({
            timeout: 30000,
            cache: false,
            dataType: 'json',
            method: 'GET',
            url: gNoticeUrl,
            data: {count: val},
            success: function(data) {
                if (('success' in data) && data.success && ('newNotice' in data) && data.newNotice) {
                    if ('countNotice' in data) {
                        $('.notice-block-val').html(data.countNotice);
                        $('.notice-block-val').show();
                    }
                }
                setTimeout(function(){
                    updateNotice();
                }, 30000);
            },
            error: function(xhr) {
                setTimeout(function(){
                    updateNotice();
                }, 30000);
            }
        });
    }
    
    if ($('.notice-block-val').length && !(typeof gNoticeUrl === 'undefined')) {
        updateNotice();
    }
    
    /**
     * news
     */
    var newsContainerItems = $('#newsContainerItems');
    var loadNewsFlag = false;
    function loadNews() {
        var url = $(newsContainerItems).attr('data-url');
        if (!url) return;
        loadNewsFlag = true;
        var obj = newsContainerItems;
        $.ajax({
            cache: false,
            dataType: 'json',
            url: url,
            success: function(data) {
                if (('success' in data) && ('content' in data)) {
                    if (data.success) {
                        if (data.content) {
                             var _last = $(newsContainerItems).find('.masonry-grid-item:last');
                             var content = $(data.content);
                             $(newsContainerItems).append(content).masonry('appended', content);
                             $(_last).nextAll('.masonry-grid-item').each(function(){
                                $.HSCore.helpers.bgImage($(this).find('[data-bg-img-src]'));
                             });
                        }
                    }
                }
                if ('nextUrl' in data) {
                    if (data.nextUrl) $(obj).attr('data-url', data.nextUrl);
                    else $(obj).attr('data-url', '');
                }
            },
            complete: function() {
                loadNewsFlag = false;
            }
        });
    }
    
    if (newsContainerItems.length) {
        newsContainerItems.masonry({
            columnWidth: '.masonry-grid-sizer',
            itemSelector: '.masonry-grid-item',
            percentPosition: true,
        });
        //Вызывало ошибку, удалил, видимого эффекта нет
        //newsContainerItems.imagesLoaded().progress(function() {
       //     newsContainerItems.masonry('layout');
      //  });
        
        $(window).scroll(function() {
            var elem = newsContainerItems;
            var scroll = $(window).scrollTop() + $(window).height();
            var offset = elem.offset().top + elem.height();
 
            if ((scroll > offset) && !loadNewsFlag) {
                loadNews();
            }
        });
    }
    
    var mainNewsCarousel = $('#mainNewsCarousel');
    var loadCarouselNewsFlag = false;
    function loadCarouselNews() {
        var url = $(mainNewsCarousel).attr('data-url');
        if (!url) return;
        loadCarouselNewsFlag = true;
        var obj = mainNewsCarousel;
        $.ajax({
            cache: false,
            dataType: 'json',
            url: url,
            success: function(data) {
                if (('success' in data) && ('content' in data)) {
                    if (data.success) {
                        if (data.content) {
                             $(mainNewsCarousel).slick('slickAdd', data.content);
                        }
                    }
                }
                if ('nextUrl' in data) {
                    if (data.nextUrl) $(obj).attr('data-url', data.nextUrl);
                    else $(obj).attr('data-url', '');
                }
            },
            complete: function() {
                loadCarouselNewsFlag = false;
            }
        });
    }
    
    if (mainNewsCarousel.length) {
        $(mainNewsCarousel).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var test = (!$(mainNewsCarousel).find('div.js-slide:last').hasClass('slick-active')
                && $(mainNewsCarousel).find('div.js-slide:eq(-2)').hasClass('slick-active'));
            if (!test) return;
            if (!loadCarouselNewsFlag) loadCarouselNews();
        });
    }


    
});
